/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiChangeExternalUserIdRequestFromJSON(json) {
    return StreemApiChangeExternalUserIdRequestFromJSONTyped(json, false);
}
export function StreemApiChangeExternalUserIdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'updateExternalUserId': !exists(json, 'update_external_user_id') ? undefined : json['update_external_user_id'],
    };
}
export function StreemApiChangeExternalUserIdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'update_external_user_id': value.updateExternalUserId,
    };
}
//# sourceMappingURL=StreemApiChangeExternalUserIdRequest.js.map